var _rect, _path, _path2, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicleUtilize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 100,
    viewBox: "0 0 120 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 119,
    height: 99,
    rx: 11.5,
    fill: "#F8FBFF",
    stroke: "#EBF1FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5913 60.9004V67.7429C36.7358 68.3946 37.5451 69.7538 39.6262 69.9772H94.8322C95.5548 69.791 96.9999 69.0835 96.9999 67.7429V55.594L89.9185 44.4227C89.485 43.9106 88.271 42.9145 86.8837 43.0262H73.588V60.9004H36.5913ZM78.0681 47.6343V56.5714H91.7973L86.0166 47.6343H78.0681Z",
    fill: "#F1453D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7324 37.0225V60.9014H34.5679C33.749 60.9014 32.14 60.5104 32.2556 58.9464C32.3712 57.3825 33.5563 56.7122 34.1344 56.5725H36.7357V51.9643H29.6543C28.9799 51.7316 27.631 50.931 27.631 49.5904C27.631 48.2498 28.9799 47.5423 29.6543 47.3561H36.7357V43.0272H24.5962C24.1626 43.0272 23.1221 42.3849 23.0065 40.9326C22.8909 39.4803 24.3553 38.931 25.0297 38.6983H36.7357V36.3243C36.9669 34.5369 38.759 34.2763 39.6261 34.3693H71.2756C73.4722 35.0396 73.8287 36.4174 73.7324 37.0225Z",
    fill: "#5A50D2"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 83.4149,
    cy: 69.8395,
    rx: 7.08139,
    ry: 6.84247,
    fill: "#465A63"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 83.2703,
    cy: 69.9794,
    rx: 2.60133,
    ry: 2.51356,
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.4417,
    cy: 69.8395,
    rx: 7.08139,
    ry: 6.84247,
    fill: "#465A63"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.2966,
    cy: 69.9794,
    rx: 2.60133,
    ry: 2.51356,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8852 50.8629H55.0754C56.0061 50.8629 56.7607 50.1083 56.7607 49.1776C56.7607 48.4525 57.2244 47.8087 57.9121 47.579L59.2677 47.1263C59.8742 46.9237 60.5411 47.0234 61.0618 47.3944L61.4857 47.6964C62.2694 48.2548 63.3396 48.176 64.033 47.5087L65.9855 45.6299C66.5905 45.0477 66.5604 44.0704 65.9207 43.5266C65.4213 43.102 65.2778 42.3906 65.5735 41.8056L66.4955 39.9817C66.6182 39.7389 66.6902 39.4735 66.7068 39.2019L67.0805 33.1119C67.1034 32.7377 67.0208 32.3646 66.8419 32.0352L65.5969 29.7418C65.2919 29.1801 65.4347 28.4804 65.9354 28.0831C66.5599 27.5876 66.6039 26.6552 66.029 26.103L63.8828 24.0417C63.1226 23.3116 61.9242 23.3036 61.1544 24.0235C60.5922 24.5493 59.7765 24.7022 59.062 24.4159L57.6729 23.8591C57.1219 23.6383 56.7607 23.1044 56.7607 22.5107C56.7607 21.7085 56.1103 21.0581 55.308 21.0581H51.6525C50.8052 21.0581 50.0798 21.6656 49.9312 22.4998C49.8216 23.1147 49.3923 23.6245 48.805 23.8371L46.8505 24.5446C46.309 24.7406 45.7054 24.513 45.4282 24.0082C45.0698 23.3555 44.2007 23.1999 43.6381 23.6875L40.8083 26.1403C40.1983 26.6689 40.2044 27.6173 40.821 28.1381C41.2651 28.5132 41.4101 29.1353 41.1777 29.6681L40.0788 32.1876C39.8167 32.7886 39.2233 33.1772 38.5676 33.1772C37.6571 33.1772 36.9189 33.9153 36.9189 34.8258V38.0234C36.9189 38.9017 37.6309 39.6136 38.5092 39.6136C39.0281 39.6136 39.5144 39.8668 39.812 40.292L40.8614 41.7914C41.2581 42.3582 41.1413 43.1365 40.5955 43.5618C39.946 44.0679 39.925 45.0428 40.552 45.5765L43.2274 47.854C43.7873 48.3306 44.5955 48.3776 45.2069 47.9692C45.648 47.6745 46.2042 47.6108 46.7006 47.7979L49.022 48.6733C49.4625 48.8394 49.7541 49.261 49.7541 49.7317C49.7541 50.3564 50.2605 50.8629 50.8852 50.8629Z",
    fill: "#375E7D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8955 27.3782C86.8955 30.1963 84.7302 32.4809 82.0591 32.4809C79.388 32.4809 77.2227 30.1963 77.2227 27.3782C77.2227 24.56 79.388 22.2754 82.0591 22.2754C84.7302 22.2754 86.8955 24.56 86.8955 27.3782Z",
    fill: "#375E7D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8955 27.3782C86.8955 30.1963 84.7302 32.4809 82.0591 32.4809C79.388 32.4809 77.2227 30.1963 77.2227 27.3782C77.2227 24.56 79.388 22.2754 82.0591 22.2754C84.7302 22.2754 86.8955 24.56 86.8955 27.3782Z",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5488 40.1809C79.5488 42.9991 77.3835 45.2837 74.7124 45.2837C72.0413 45.2837 69.876 42.9991 69.876 40.1809C69.876 37.3627 72.0413 35.0781 74.7124 35.0781C77.3835 35.0781 79.5488 37.3627 79.5488 40.1809Z",
    fill: "#375E7D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5488 40.1809C79.5488 42.9991 77.3835 45.2837 74.7124 45.2837C72.0413 45.2837 69.876 42.9991 69.876 40.1809C69.876 37.3627 72.0413 35.0781 74.7124 35.0781C77.3835 35.0781 79.5488 37.3627 79.5488 40.1809Z",
    stroke: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5847 37.3618C76.0843 34.0296 73.115 35.0478 71.9429 36.0465C76.6938 37.0403 76.2666 42.5988 75.4591 45.1807C80.1475 43.8654 79.7911 38.9694 78.5847 37.3618Z",
    fill: "#2B4D66"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0696 24.5991C83.5691 21.2669 80.5998 22.2851 79.4277 23.2838C84.1786 24.2776 83.7515 29.8361 82.944 32.418C87.6324 31.1027 87.276 26.2067 86.0696 24.5991Z",
    fill: "#2B4D66"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9013 21.3354H50.583C62.3147 30.577 57.4473 44.8509 53.5471 50.8327H56.9793V47.9266L60.3334 46.7641L63.1416 48.5805L67.1197 44.5119L65.0916 42.7682L66.7297 39.7168L67.4642 36.0841L67.1197 32.5967L65.0916 28.8187L67.1197 27.293L62.5175 22.9338L60.4114 24.9681L56.9013 23.5151V21.3354Z",
    fill: "#2B4D66"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M60.729 36.4826C60.729 40.3576 57.3699 43.4989 53.2263 43.4989C49.0827 43.4989 45.7236 40.3576 45.7236 36.4826C45.7236 32.6076 49.0827 29.4663 53.2263 29.4663C57.3699 29.4663 60.729 32.6076 60.729 36.4826Z",
    fill: "#EFF6FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.729 36.4826C60.729 40.3576 57.3699 43.4989 53.2263 43.4989C49.0827 43.4989 45.7236 40.3576 45.7236 36.4826C45.7236 32.6076 49.0827 29.4663 53.2263 29.4663C57.3699 29.4663 60.729 32.6076 60.729 36.4826Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleUtilize);
export default __webpack_public_path__ + "static/media/vehicle-utilize.4471dbcefbdaef25312af2c22a85cf6f.svg";
export { ForwardRef as ReactComponent };